import { api } from './client';
import type { Envelope } from './types';

export interface PayoutAccount {
  bankName: string;
  accountNumber: string;
  holderName: string;
}

export async function getMyPayoutAccount(): Promise<PayoutAccount | null> {
  const { data } = await api.get<Envelope<PayoutAccount | null>>('/me/payout-account');
  // 미등록이면 직렬화에서 data 필드가 생략될 수 있다 — undefined 는 TanStack Query 에서 금지값.
  return data.data ?? null;
}

export async function updateMyPayoutAccount(input: PayoutAccount) {
  const { data } = await api.put<Envelope<PayoutAccount>>('/me/payout-account', input);
  return data.data;
}

export async function deleteMyPayoutAccount() {
  await api.delete('/me/payout-account');
}

export async function listMeetingPayoutAccounts(
  meetingId: string,
): Promise<Record<string, PayoutAccount>> {
  const { data } = await api.get<Envelope<Record<string, PayoutAccount>>>(
    `/meetings/${meetingId}/payout-accounts`,
  );
  return data.data ?? {};
}
